import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 13L11.5 21.5L11.9932 21.4178C13.4398 21.1767 14.5 19.9251 14.5 18.4586V15H20.8195C21.4375 15 21.9075 14.4451 21.8059 13.8356L20.1393 3.8356C20.0589 3.35341 19.6417 3 19.1529 3H8V13Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3V13M8 13V3H19.1529C19.6417 3 20.0589 3.35341 20.1393 3.8356L21.8059 13.8356C21.9075 14.4451 21.4375 15 20.8195 15H14.5V18.4586C14.5 19.9251 13.4398 21.1767 11.9932 21.4178L11.5 21.5L8 13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbDown = Vue.extend<IconProps>({
  name: 'ThumbDownIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'thumb-down',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ThumbDown;
